// Given an object with crop aggregates, returns an array of crop names.
// This only includes crops that are instantiated in sections,
// ie. there is at least one stem on the farm.
export const getCropNames = ({ cropAggregates }) =>
  cropAggregates.map(({ crop }) => crop.name);

/*
 * Given a year index and an absolute start year, return the year index relative
 * to a different farm start year. Needed to handle year indices across multiple
 * farms with potentially different start years. If one or both of the start
 * years are not provided (which would typically occur in cases where we are
 * only handling data for a single farm), return the given year index. Assumes
 * farmStartYear >= startYear.
 *
 * E.g. If the farmStartYear is 2025, and the given startYear is 2024, then the
 * relative year index for the farm is one less than the given yearIndex. A year
 * index of 0 relative to 2024 would be a year index of -1 relative to 2025, a
 * year index of 1 relative to 2024 would be a year index of 0 relative to 2025,
 * and so on.
 */
export const getRelativeYearIndex = (yearIndex, startYear, farmStartYear) => {
  return farmStartYear && startYear
    ? yearIndex - Math.abs(farmStartYear - startYear)
    : yearIndex;
};
